import axios from "axios";
import { get } from "./api_helper";
import * as url from "./url_helper";

// get actual card counts data from the API.
export const fetchDashboardApi = (city) => get(url.DASHBOARD_API + `?city=${city}`);
export const fetchDashboardTopRentedToysApi = (city) => get(url.DASHBOARD_TOP_RENTED_TOYS + `?city=${city}`);